import React from 'react'
import { Component, LocaleCode } from '../types/component'
import { getLocalizedText } from '../utils/localization'
import { cn } from '../lib/utils'

interface FeaturesProps {
  component: Component
  locale: LocaleCode
  storeId: string
  apiUrl: string
  style: React.CSSProperties
}

export function Features({ component, locale, style }: FeaturesProps) {
  const config = component.config as any

  const title = getLocalizedText(config.title, locale)
  const subtitle = getLocalizedText(config.subtitle, locale)
  const items = config.items || []
  const columns = config.columns || 3
  const layoutType = config.layout || 'grid'

  const gridColsMap = {
    2: 'md:grid-cols-2',
    3: 'md:grid-cols-3',
    4: 'md:grid-cols-4',
  }
  const gridCols = gridColsMap[columns as keyof typeof gridColsMap] || 'md:grid-cols-3'

  return (
    <div style={style} className="w-full">
      <div className="max-w-7xl mx-auto">
        {(title || subtitle) && (
          <div className="text-center mb-12">
            {title && (
              <h2 className="text-3xl font-bold mb-4" style={{ color: style.color }}>
                {title}
              </h2>
            )}
            {subtitle && (
              <p className="text-lg opacity-80" style={{ color: style.color }}>
                {subtitle}
              </p>
            )}
          </div>
        )}

        {layoutType === 'grid' ? (
          <div className={cn('grid grid-cols-1 gap-8', gridCols)}>
            {items.map((item: any, index: number) => (
              <div
                key={index}
                className="text-center p-6 rounded-lg transition-transform hover:scale-105 shadow-md"
                style={{
                  backgroundColor: style.backgroundColor === '#ffffff' || !style.backgroundColor ? 'rgba(0,0,0,0.02)' : 'rgba(255,255,255,0.1)',
                }}
              >
                {item.icon && (
                  <div className="text-4xl mb-4">
                    {item.icon}
                  </div>
                )}
                <h3 className="text-xl font-semibold mb-2" style={{ color: style.color }}>
                  {getLocalizedText(item.title, locale)}
                </h3>
                <p className="opacity-70" style={{ color: style.color }}>
                  {getLocalizedText(item.description, locale)}
                </p>
              </div>
            ))}
          </div>
        ) : (
          <div className="space-y-6">
            {items.map((item: any, index: number) => (
              <div
                key={index}
                className="flex items-start gap-4 p-6 rounded-lg"
                style={{
                  backgroundColor: style.backgroundColor === '#ffffff' || !style.backgroundColor ? 'rgba(0,0,0,0.02)' : 'rgba(255,255,255,0.1)',
                }}
              >
                {item.icon && (
                  <div className="text-3xl flex-shrink-0">
                    {item.icon}
                  </div>
                )}
                <div className="flex-1">
                  <h3 className="text-lg font-semibold mb-1" style={{ color: style.color }}>
                    {getLocalizedText(item.title, locale)}
                  </h3>
                  <p className="opacity-70" style={{ color: style.color }}>
                    {getLocalizedText(item.description, locale)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
